var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx } from "react/jsx-runtime";
import React, { createContext, useCallback, useMemo } from 'react';
import { NotImplementedErrorHandler, StorageKeys, } from '../../services';
import { NotificationType } from '../NotificationsMessageContext/NotificationsMessageContext';
import { useNotificationsMessage } from '../NotificationsMessageContext/useNotificationsMessage';
import { useDispatch } from 'react-redux';
import { useStorage } from '../StorageContext/useStorage';
import { useQueryClient } from '@tanstack/react-query';
import { useReminder } from '../ReminderContext/useReminder';
import { createLogoutService } from '../../services/LogoutService';
export var ErrorHandlerContext = createContext({
    errorHandler: new NotImplementedErrorHandler(),
});
export var ErrorHandlerProvider = function (_a) {
    var children = _a.children, ErrorHandlerImplementation = _a.ErrorHandlerImplementation, errorHandlerInstance = _a.errorHandlerInstance, providedAuthRepo = _a.authRepo;
    var showNotifications = useNotificationsMessage().showNotifications;
    var dispatch = useDispatch();
    var storage = useStorage();
    var queryClient = useQueryClient();
    var resetReminder = useReminder().resetReminder;
    var nonBlockingInteractionError = useMemo(function () {
        return function (message) {
            return showNotifications({
                type: NotificationType.error,
                text: message,
                isError: true,
            });
        };
    }, [showNotifications]);
    // Create minimal authRepo if not provided (for logout only)
    // This handles the case where RepositoriesProvider is nested inside ErrorHandlerProvider
    var authRepo = useMemo(function () {
        if (providedAuthRepo) {
            return providedAuthRepo;
        }
        // Minimal implementation that only supports revokeToken for logout
        // This is safe because revokeToken only needs storage access
        return {
            signIn: function () {
                throw new Error('AuthRepository not available in ErrorHandlerProvider');
            },
            signUp: function () {
                throw new Error('AuthRepository not available in ErrorHandlerProvider');
            },
            verifyCode: function () {
                throw new Error('AuthRepository not available in ErrorHandlerProvider');
            },
            refreshAccessToken: function () {
                throw new Error('AuthRepository not available in ErrorHandlerProvider');
            },
            addConsumer: function () {
                // No-op: consumers are managed by the real AuthRepository
            },
            revokeToken: function () { return __awaiter(void 0, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: 
                        // Minimal revokeToken: only remove tokens from storage
                        // Note: This doesn't notify authConsumers, but that's acceptable
                        // because the real AuthRepository will handle that when RepositoriesProvider is available
                        return [4 /*yield*/, storage.removeItem(StorageKeys.ACCESS_TOKEN_KEY)];
                        case 1:
                            // Minimal revokeToken: only remove tokens from storage
                            // Note: This doesn't notify authConsumers, but that's acceptable
                            // because the real AuthRepository will handle that when RepositoriesProvider is available
                            _a.sent();
                            return [4 /*yield*/, storage.removeItem(StorageKeys.REFRESH_TOKEN_KEY)];
                        case 2:
                            _a.sent();
                            return [2 /*return*/];
                    }
                });
            }); },
        };
    }, [providedAuthRepo, storage]);
    var sendLogout = useCallback(function () { return __awaiter(void 0, void 0, void 0, function () {
        var accessToken, logoutService;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, storage.getItem(StorageKeys.ACCESS_TOKEN_KEY)];
                case 1:
                    accessToken = _a.sent();
                    // Se non c'è token, non fare logout (utente già non autenticato)
                    if (!accessToken) {
                        return [2 /*return*/];
                    }
                    logoutService = createLogoutService({
                        dispatch: dispatch,
                        storage: storage,
                        queryClient: queryClient,
                        authRepo: authRepo,
                        resetReminder: resetReminder,
                    });
                    return [4 /*yield*/, logoutService()];
                case 2:
                    _a.sent();
                    // Platform-specific navigation (after cleanup)
                    if (typeof window !== 'undefined' && window.location) {
                        // Web: redirect to intro page
                        window.location.href = '/intro';
                    }
                    return [2 /*return*/];
            }
        });
    }); }, [dispatch, storage, queryClient, authRepo, resetReminder]);
    var errorHandler = useMemo(function () {
        if (errorHandlerInstance) {
            return errorHandlerInstance;
        }
        if (ErrorHandlerImplementation) {
            return new ErrorHandlerImplementation(nonBlockingInteractionError, sendLogout);
        }
        throw new Error('No instance found, should exist at least one between ErrorHandlerImplementation or errorHandlerInstance');
    }, [
        ErrorHandlerImplementation,
        errorHandlerInstance,
        nonBlockingInteractionError,
        sendLogout,
    ]);
    return (_jsx(ErrorHandlerContext.Provider, { value: { errorHandler: errorHandler }, children: children }));
};
